<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <vxe-grid
      ref="table"
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :row-class-name="rowClassName"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      row-id="waybillDetailCode"
      :checkboxConfig="{
        reserve: true,
        highlight: false
      }"
    >
      >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:orderso="{ row }">
        <div>
          <span>{{ row.orderSoNo ? row.orderSoNo : '--' }}</span>
        </div>
      </template>
      <template v-slot:orderStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.orderStatus === 'N'
              ? 'success'
              : row.orderStatus === 'Y'
              ? 'light'
              : 'warning'
          "
        >
          {{ row.orderStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            content="送达"
            v-allow="'actReceive'"
            placement="top"
          >
            <i
              class="el-icon-takeaway-box tool-btn"
              @click="isReceive(row)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="拒收"
            v-allow="'actRejection'"
            placement="top"
          >
            <i class="el-icon-circle-close tool-btn" @click="isReason(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:orderNo="{ row }">
        <div>
          <el-link type="primary" @click="openOrderDetailPage(row.orderNo)">
            {{ row.orderNo }}
          </el-link>
        </div>
      </template>
    </vxe-grid>
    <set-receive
      :selectList="selectList"
      @comitOk="comitOk()"
      v-if="showCommitForm"
    />
    <set-reason
      @comitOk="comitOk()"
      :selectCodeList="selectCodeList"
      v-if="showReasonForm"
      @closeReason="closeReason()"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import SetReceive from './set-receive.vue'
import SetReason from './set-reason.vue'
export default {
  components: { SetReceive, SetReason },
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    }
  },
  data() {
    return {
      tableColumns: tableColumns(),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      fullScreenLoading: false,
      selectList: [],
      selectCodeList: [],
      showCommitForm: false,
      showReasonForm: false,
      rowClassName: ({ row }) => {
        if (row.v_isAbnormal === '异常') {
          return 'bg-danger text-white'
        }
        return ''
      }
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 204
    },
    isReceive(row) {
      this.selectList = [
        {
          waybillDetailCode: row.waybillDetailCode,
          dispatchOrderNo: row.dispatchOrderNo
        }
      ]
      this.showCommitForm = true
    },
    isReason(row) {
      this.selectCodeList = []
      this.selectCodeList.push(row.waybillDetailCode)
      this.showReasonForm = true
    },
    closeReason() {
      this.showReasonForm = false
    },
    async batchIsReceive() {
      const selectCode = await this.getSelectData()
      if (!selectCode) {
        return
      }
      this.selectList = this.selectList.map((item) => ({
        waybillDetailCode: item.waybillDetailCode,
        dispatchOrderNo: item.dispatchOrderNo
      }))
      this.showCommitForm = true
    },
    comitOk() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('reload')
    },
    getSelectData(selectType) {
      // 缓存的选中数据，非当前页数据
      let reserveRecords = this.$refs.table.getCheckboxReserveRecords()
      // 当前页选中的数据
      let selectRecords = this.$refs.table.getCheckboxRecords()
      let totCount = reserveRecords.length + selectRecords.length
      if (totCount === 0) {
        this.$message.warning('请选择需要批量处理的单据')
        return false
      }
      this.selectList = []
      this.selectDispatchNoList = []
      // 将缓存中的选中数据，加入已选中数据列表
      if (reserveRecords.length > 0) {
        reserveRecords.forEach((row) => {
          if (selectType == 'code') {
            this.selectList.push(row.waybillDetailCode)
            this.selectDispatchNoList.push(row.dispatchOrderNo)
          } else {
            this.selectList.push(row)
          }
        })
      }
      // 将当前页选中数据，加入已选中数据列表
      if (selectRecords.length > 0) {
        selectRecords.forEach((row) => {
          if (selectType == 'code') {
            this.selectList.push(row.waybillDetailCode)
            this.selectDispatchNoList.push(row.dispatchOrderNo)
          } else {
            this.selectList.push(row)
          }
        })
      }
      if (totCount > 20) {
        this.$message.warning('每次批量选择单价数量，不能超过20张')
        return false
      }
      return true
    },
    getTableCheckedData(isNotEmpty) {
      const data = this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())
      if (isNotEmpty) {
        if (data === null || data === [] || data.length === 0) {
          this.$message({
            message: '请选择您要操作的数据！',
            type: 'warning'
          })
          return
        }
      }
      return data
    },
    batchExport() {
      const data = this.getTableCheckedData(true)
      if (!data) return

      this.$refs.table.exportData({
        filename: '待送达单据' + Date.now(),
        type: 'csv',
        data: data,
        columnFilterMethod({ column }) {
          return !['col-opt', 'checkbox'].includes(column.property)
        }
      })
    },
    openOrderDetailPage(no) {
      this.$router.push({
        name: 'carriage-order-detail-page',
        params: { no }
      })
    }
  }
}
</script>
